import { useState, useEffect, useRef } from "react";
import { Accordion, AccordionDetails, AccordionSummary, ClickAwayListener } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import { ServerRequestPublic, ServerRequestProtected } from "../../../utils/ServerDataRequest";
import { enumUtil } from "../../../utils/Enum";
import SuperSearch from "../../shared/SuperSearch/SuperSearch";
import Loader from "../../shared/Loader/Loader";
import NotificationHandler from "../../../utils/NotificationHandler";
import isNull from "../../../utils/NullChecking";
import FormValidator from "../../../utils/FormValidator";
import { useSelector } from "react-redux";
import { convertTimeToHMS } from "../../../utils/Constants";
import DeleteConfirmatiom from "../DeleteConfirmation";
import React from "react";
import { saveAs } from "file-saver";
import Addalert from "../AddAlert";
// import { click } from "@testing-library/user-event/dist/click";
import HTMLParser from "./ParserHtml";
import BillingBatch from "../../shared/BillingBatchesTab/BillingBatch";
import Alert from "../../shared/AlertTab/Alert";
import Notes from "../../shared/NotesTab/Notes";
import { ClaimNotes } from "../../shared/IconsComponent/icons";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

const CaregiverNotesTab = () => {
    let CaregiverIDR = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    CaregiverIDR = CaregiverIDR?.data?.id

    let PatientName = '';
    // if (!isNull(CaregiverIDR)) {
    //     PatientName =  CaregiverIDR?.data?.name + '-' +  CaregiverIDR?.data?.id
    // }
    const API_URL_Wasabi_Download = enumUtil.controller.Wasabi_Download;
    let nameIDR = useSelector(state => state[`Open_Caregiver_Tab`].find((pt) => pt.active === true));
    nameIDR = nameIDR?.data?.id
    const API_URL = enumUtil.controller.Caregive
    const API_URL_General = enumUtil.controller.General
    const API_URL_ClaimOptions = enumUtil.controller.ClaimOptions

    let Note_Modal = {
        Note: "",
        NoteReply: ""
    }
    let Pt_Summary = {
        CaregiveName: "",
        FirstClaim: "",
        PrimaryInsurance: "",
        SubscriberID: "",
        CaregiveBalance: "",
        LastCaregivePayment: "",
        Insurancebalance: "",
        LastInsurancePayment: "",
        LastStatementBal: "",
        LastStatementSent: "",
        LastStatementCount: "",
        SpecialistCopay: "",
        CoPay: "",
        Eligibility: "",
        LastVisit: "",
        NextAppointment: "",
    }
    let File_Modal = {
        NoteFile: [],
        NoteReplyFile: []
    };
    let valModal = {}
    let ValidationModal = {
        NoteVal: "",
    }
    let defaultAccordion = { AccSummFor: false, Notes: false, Alert: false, BillingBatch: false, };
    const [openedAccordComponentLoad, setOpenedAccordComponentLoad] = useState(defaultAccordion);
    const [isOpenAlertType, setisOpenAlertType] = useState(false)
    const [expanded, setExpanded] = useState('summarypt');
    const [activeNotes, setActiveNotes] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [newNoteSaved, setNewNoteSaved] = useState(false)
    const [notesData, setNotesData] = useState([])
    const [NoteID, setNoteID] = useState(0);
    const [mainNoteModal, setMainNoteModal] = useState(Note_Modal);
    const [noteSaveUpdateModal, setNoteSaveUpdateModal] = useState({})
    const [NoteValidationModal, setNoteValidationModal] = useState(ValidationModal)
    const [del, setDel] = useState(false)
    const [delID, setDelID] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState(File_Modal);
    const [ClaimSummary, setClaimSummary] = useState({})
    const [alertData, setAlertData] = useState([]);
    const [PerPage, setPerPage] = useState(10);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();
    const [Contains, setAlertCode] = useState();
    const [isClose, setIsClose] = useState();
    const [id, setID] = useState();
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [CaregiveSummary, setCaregiveSummary] = useState(Pt_Summary)
    const [CaregiveNotesID, setCaregiveNotesID] = useState(null)
    const [isAccending, setIsAccending] = useState('')
    const [Name, setName] = useState("")
    const [refresh, setRefresh] = useState(false)
    const messagefieldRES = useRef(null)
    // const [other, setother] = useState(false)
    const NoteValidation = async () => {
        let ValidationModal = {
            NoteVal: FormValidator(
                mainNoteModal.Note,
                enumUtil.enumValidationType.Required,
                'Note',
            )
        }
        await setNoteValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const ReplyNoteValidation = async () => {
        let ValidationModal = {
            ReplyNoteVal: FormValidator(
                mainNoteModal.NoteReply,
                enumUtil.enumValidationType.Required,
                'Reply Note',
            )
        }
        await setNoteValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const AddNote = (ID, Note, filename) => {
        if (ID != NoteID) {
            setMainNoteModal({ ...Note_Modal, Note: Note })
            setNoteSaveUpdateModal({ ...Note_Modal, Note: Note })

            if (filename) { setSelectedFiles({ ...selectedFiles, NoteFile: [{ name: filename }] }) }
            else { setSelectedFiles({ ...selectedFiles, NoteFile: [] }) }
        }

        setNoteID(ID)
        messagefieldRES.current.scrollIntoView({ behavior: "smooth" })
        messagefieldRES.current.focus()
    }
    useEffect(() => {

    }, [selectedFiles])

    const [activeTab, setActiveTab] = useState('')
    const handleOpenNotes = () => {
        setActiveNotes(!activeNotes)
    }
    const handleActiveTab = (key) => {
        setActiveTab(key)
        setActiveNotes(!activeNotes)

    }

    const LoadData = () => {
        setNotesData([])
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/FindbySingleCriteria', 'post', {
            "ID": nameIDR,
            "TableName": enumUtil.enumAPITableName.CaregiveNotes,
            "SearchParam": ""
        })
            .then((response) => {
                setIsLoading(false);
                setNotesData(response.Rows)
                setMainNoteModal(response.Rows)
            }).catch((error) => {
                setIsLoading(false);
            })
    }
    const loadAlertData = () => {
        setAlertData([]);
        setIsLoading(true);
        ServerRequestProtected(API_URL_General + '/FindByMultipleCriteria', 'post', {
            "TableName": enumUtil.enumAPITableName.Alert,
            "SearchCriteria": { "CaregiveID": CaregiverIDR },
            "SearchParam": "",
            "PerPage": PerPage,
            "PageNo": PageNo,
        })
            .then((response) => {
                setIsLoading(false);
                setAlertData(response.Rows);
                setMainNoteModal(response.Rows);
                setRefresh(!refresh)
            }).catch((error) => {
                setIsLoading(false);
            })
    }
    const LoadDataPtSummary = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/FindCaregiveShortSummary", 'post', {
            "ID": CaregiverIDR + "",
            "TableName": enumUtil.enumAPITableName.CaregiveSummary
        }).then((response) => {
            setIsLoading(false)
            setCaregiveSummary(response[0])
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    useEffect(() => {
        if (activeNotes) {
            // LoadData();
            loadAlertData();
            LoadDataPtSummary();
        }
    }, [activeNotes])

    useEffect(() => {
        // activeNotes && nameIDR && LoadData();
        // if (!isNull(ClaimID)) {
        //     handleAccountSuummary()
        // }
    }, [newNoteSaved])
    const AddAlertcode = (ID) => {
        setisOpenAlertType(true)
        setAlertCode(ID)
    }
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    const handleNoteChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainNoteModal };
        let saveModal = { ...noteSaveUpdateModal }
        modal[name] = value
        setMainNoteModal(modal)
        for (var property in modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setNoteSaveUpdateModal(saveModal)
    }
    const handleKey = (e, NoteReply, ParentID) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            NoteReply === "NoteReply" ? handleSaveNote(NoteReply, ParentID) : handleSaveNote();
        }
        else if (e.key === 'Enter' && e.shiftKey) {
            handleNoteChange(e);
        }
    }
    const sortedAscending = (e) => {
        e.stopPropagation()
        setIsAccending('Acc')
        let data = [...notesData];
        data.sort((a, b) => new Date(a.EnteredDate) - new Date(b.EnteredDate));
        setNotesData(data);
    }
    const sortedDescending = (e) => {
        e.stopPropagation()
        setIsAccending('Des')
        let data = [...notesData];
        data.sort((a, b) => new Date(b.EnteredDate) - new Date(a.EnteredDate));
        setNotesData(data);
    }
    const getid = (id, name) => {
        setCaregiveNotesID(id)
        setName(name)
        messagefieldRES.current.scrollIntoView({ behavior: "smooth" })
        messagefieldRES.current.focus()
    }
    const handleSaveNote = async (NoteReply, ParentID) => {
        // NoteReply !== "NoteReply" ? await NoteValidation() : await ReplyNoteValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {



            let modalNote = {
                TableName: enumUtil.enumAPITableName.CaregiveNotes,
                ID: NoteID + "",
                data: {
                    CaregiveID: nameIDR,
                    Note: noteSaveUpdateModal.Note,
                    FileName: selectedFiles?.NoteFile[0]?.name,
                    NoteFile: noteSaveUpdateModal.NoteFilebase64
                },
                value: null
            }
            let modalReplyNote = {
                TableName: enumUtil.enumAPITableName.CaregiveNotes,
                ID: "0",
                data: {
                    CaregiveID: nameIDR,
                    Note: noteSaveUpdateModal.Note,
                    FileName: selectedFiles?.NoteFile[0]?.name,
                    NoteFile: noteSaveUpdateModal.NoteFilebase64,
                    CaregiveNotesID: CaregiveNotesID
                }
            }


            let saveModal;

            if (CaregiveNotesID === null) {

                saveModal = modalNote
            } else {
                saveModal = modalReplyNote
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal).then((response) => {
                if (!isNull(response.id)) {
                    setCaregiveNotesID(null)
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    handleSetDefault()
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const onCloseDelete = () => {
        setDel(false);
        setIsOpenDelete(false)
    }
    const handleDelete = (id) => {
        setDelID(id)
        setDel(!del)
    }
    const handleSetDefault = () => {
        setNoteID(0);
        setMainNoteModal(Note_Modal)
        setNoteSaveUpdateModal(Note_Modal)
        setSelectedFiles(File_Modal);
        setNewNoteSaved(!newNoteSaved)
        loadAlertData();
    }
    let DeleteConfirmations = '';
    if (del) {
        DeleteConfirmations = <DeleteConfirmatiom isOpenAlert={del} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.CaregiveNotes} ID={delID} onClose={handleSetDefault} />
    }
    const handleDeleteModal = (ID) => {
        setID(ID)
        setIsOpenDelete(true)
    }
    let DeleteConfirmation = "";
    if (isOpenDelete) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenDelete} onCloseDelete={onCloseDelete} API_URL={API_URL_General} TableName={enumUtil.enumAPITableName.Alert} ID={id} onClose={handleSetDefault} />
    }
    const handleFileChange = (event) => {
        let { name, files } = event.target;
        setSelectedFiles({ ...selectedFiles, [name]: Array.from(files) });
        const file = files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setNoteSaveUpdateModal({ ...noteSaveUpdateModal, [`${name}base64`]: event.target.result.split("base64,")[1] })
            };
            reader.readAsDataURL(file);
        };
    };
    const handleRemove = (index, name) => {
        const updatedFiles = [...selectedFiles[name]];
        updatedFiles.splice(index, 1);
        setSelectedFiles({ ...selectedFiles, [name]: updatedFiles });
    }
    const handleDownloadFile = (FilePath) => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi_Download, 'post', {
            "BucketPath": FilePath
        }, "Download")
            .then((response) => {
                setIsLoading(false)
                let blob = new Blob([response]);
                saveAs(blob, FilePath.split("/").pop());
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    // const handleEdit = (node) => {
    //     setIsLoading(true)
    //     ServerRequestProtected(API_URL + "/FindByID", 'post', {
    //       "TableName": enumUtil.enumAPITableName.Alert,
    //       "ID": node.DocumentTypeID + ""
    //     }).then((response) => {
    //       setIsOpenDocumentType(true)
    //       setmainDocumentModal(response)
    //       setDocumentTypeID(response.DocumentTypeID + "")
    //       setIsLoading(false)
    //     }).catch((error) => {
    //       setIsLoading(false)
    //       NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //     })
    //   }
    // const handleAccountSuummary = () => {
    //     if (ClaimID.data.id != -1 && ClaimID.data.id != -2) {
    //         let data = {
    //             ClaimIDs: ClaimID.data.id + ""
    //         }
    //         setIsLoading(true)
    //         ServerRequestProtected(API_URL_ClaimOptions + "/VisitSummary", 'post', {
    //             TableName: enumUtil.enumAPITableName.VisitSummary,
    //             Data: data
    //         })
    //             .then((response) => {
    //                 setIsLoading(false)
    //                 setClaimSummary(response[0])
    //             }).catch((error) => {
    //                 setIsLoading(false)
    //                 NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //             })
    //     }
    // }
    const CloseCategory = () => {
        setisOpenAlertType(false)
    }
    let PopupScreenAlert = "";
    if (isOpenAlertType) {
        PopupScreenAlert = <Addalert isOpenAlertType={isOpenAlertType} loadAlertData={loadAlertData} onClose={CloseCategory} Contains={Contains} type="Caregiver" />
    }
    const handleChangeAccodian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const [other, setOther] = useState(false);
    const [expandedItemId, setExpandedItemId] = useState([]);
    const otherMsg = (itemId) => {

        if (expandedItemId.includes(itemId)) {
            setExpandedItemId(expandedItemId?.filter((_itemId) => _itemId !== itemId))

        }
        else {
            setExpandedItemId([...expandedItemId, itemId])

        }
        // setExpandedItemId(itemId);
        setOther(!other);
    };


    // Update the width when the component mounts or whenever Name changes
    let ReplyerRef = useRef(null);
    const [ReplyerWidth, setReplyerWidth] = useState(0);

    useEffect(() => {
        setReplyerWidth(ReplyerRef.current?.clientWidth);
    }, [Name]);


    return (
        <>
            {DeleteConfirmations}
            {PopupScreenAlert}
            <div className="ar_claims-TabHeader__notes">
                <div className="direction-icon">
                    <div className="claims-TabHeader__notes__CloseBtn">
                        <i className="icon-right-direction"></i>
                    </div>
                    <div className='action-buttons d-flex flex-column gap-10' onClick={() => setActiveNotes(!activeNotes)}>
                        <div className="d-flex align-items-center gap-10 px-10 cursor-pointer ar-options">
                            <ClaimNotes />
                            <p className="text text-nowrap ">Patient Summary</p>
                        </div>
                        <div className="d-flex align-items-center gap-10 px-10 cursor-pointer ar-options">
                            <span class="icon-claim-message fs-16"><span class="path1"></span><span class="path2"></span></span>
                            <p className="text text-nowrap ">Notes</p>
                        </div>
                        <div className="d-flex align-items-center gap-10 px-10 cursor-pointer ar-options">
                            <span class="icon-claim-alert fs-19"></span>
                            <p className="text text-nowrap ">Alerts</p>
                        </div>
                        <div className="d-flex align-items-center gap-10 px-10 cursor-pointer ar-options">
                            <span class="icon-claim-batches fs-19"><span class="path1"></span><span class="path2"></span></span>
                            <p className="text text-nowrap ">Billing Batch Doc</p>
                        </div>
                    </div>
                </div>
                <div className={`claims-TabHeader__notes ${activeNotes ? "active__notes" : ""} ${activeTab === "notes" ? "notes_size" : ""}`}>

                    <div className="d-flex align-items-center justify-content-between px-10">
                        <p className="heading fs-14">{'abc'}</p>
                        <i className="icon-Icon-metro-cross fs-14" onClick={() => handleOpenNotes()}></i>
                    </div>
                    {/* new design notes  */}
                    <div className="ar-summary-tabs_content">
                        <Tab.Container activeKey={activeTab} onSelect={(key) => setActiveTab(key)} >
                            <div className='ms-0 px-10 my-12'>
                                <Nav variant="tabs" className="d-flex border-0 gx-0 align-items-center gap-1">
                                    <Nav.Item className="ar-copay-link ar-pad">
                                        <Nav.Link eventKey="summary" className="text font-m">Summary</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="ar-copay-link ar-pad">
                                        <Nav.Link eventKey="notes" className="text font-m">Notes</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="ar-copay-link ar-pad">
                                        <Nav.Link eventKey='alert' className="text font-m">Alerts</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="ar-copay-link ar-pad">
                                        <Nav.Link eventKey='billingbatch' className="text font-m">Billing Batch Documents</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                            <Tab.Content>
                                <Tab.Pane eventKey='summary'>
                                    <div className="patient_notes_content">
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">First Claim:</p>
                                                <p className="value">{!isNull(CaregiveSummary.FirstClaim) ? CaregiveSummary.FirstClaim : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Primary Insurance:</p>
                                                <p className="value">{!isNull(CaregiveSummary.PrimaryInsurance) ? CaregiveSummary.PrimaryInsurance : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Subscriber ID:</p>
                                                <p className="value">{!isNull(CaregiveSummary.SubscriberID) ? CaregiveSummary.SubscriberID : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Caregive Bal:</p>
                                                <span className="bg_color">
                                                    <p className="value">{!isNull(CaregiveSummary.CaregiveBalance) ? '$' + CaregiveSummary.CaregiveBalance : 'N/A'}</p>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Last Caregive Payment:</p>
                                                <p className="value">{!isNull(CaregiveSummary.LastCaregivePayment) ? '$' + CaregiveSummary.LastCaregivePayment : 'N/A'} </p>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Insurance Bal:</p>
                                                <span className="bg_color">
                                                    <p className="value">{!isNull(CaregiveSummary.Insurancebalance) ? '$' + CaregiveSummary.Insurancebalance : 'N/A'} </p>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Last Insurance Payment:</p>
                                                <p className="value">{!isNull(CaregiveSummary.LastInsurancePayment) ? '$' + CaregiveSummary.LastInsurancePayment : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Last Statement Bal:</p>
                                                <span className="bg_color">
                                                    <p className="value">{!isNull(CaregiveSummary.Balance) ? '$' + CaregiveSummary.Balance : 'N/A'}</p>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Last Statement Sent:</p>
                                                <p className="value">{!isNull(CaregiveSummary.LastStatementSent) ? '$' + CaregiveSummary.LastStatementSent : 'N/A'} </p>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Last Statement Count:</p>
                                                <p className="value">{!isNull(CaregiveSummary.LastStatementCount) ? '$' + CaregiveSummary.LastStatementCount : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Copay:</p>
                                                <p className="value">{!isNull(CaregiveSummary.CoPay) ? '$' + CaregiveSummary.CoPay : 'N/A'} </p>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Specialist Copay:</p>
                                                <p className="value">{!isNull(CaregiveSummary.SpecialistCopay) ? '$' + CaregiveSummary.SpecialistCopay : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Eligibility:</p>
                                                <p className="value">{!isNull(CaregiveSummary.Eligibility) ? CaregiveSummary.Eligibility : 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data justify-content-between">
                                                <p className="title">Last Visit:</p>
                                                <p className="value">{!isNull(CaregiveSummary.LastVisit) ? CaregiveSummary.LastVisit : 'N/A'} </p>
                                                <div className="d-flex">
                                                    <i className="icon-download-svgrepo-com"></i>
                                                    <i className="icon-Icon-awesome-eye"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="notes-content__item">
                                            <div className="notes-content__item__Data">
                                                <p className="title">Next Appointment:</p>
                                                <p className="value">{!isNull(CaregiveSummary.NextAppointment) ? CaregiveSummary.NextAppointment : 'N/A'} </p>
                                            </div>
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="notes">
                                    {isLoading ? <Loader /> : null}
                                    <Notes nameIDR={nameIDR} activeNotes={activeNotes} API_URL={enumUtil.controller.Caregive} TableName={enumUtil.enumAPITableName.CaregiveNotes} ID={'CaregiveNotesID'} type={'Caregive'} />

                                </Tab.Pane>
                                <Tab.Pane eventKey='alert'>
                                    <Alert ID={CaregiverIDR} AddAlertcode={AddAlertcode} handleDeleteModal={handleDeleteModal} refresh={refresh} type='Caregive' />

                                </Tab.Pane>
                                <Tab.Pane eventKey='billingbatch'>
                                    <BillingBatch ID={CaregiverIDR} type={'Caregiver'} />
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>

                </div >

            </div>
        </>);
}

export default CaregiverNotesTab;